<!-- 节气海报 -->
<!-- 由 suu 创建于 2023-01-11 星期三 -->
<template>
  <div class="solar-terms-poster">
    <div class="stp-mask" v-if="showMask"></div>
    <div class="stp-cent" id="box">
      <!-- <img class="c-top" :src="topImg" alt="" /> -->
      <img class="c-bg" :src="bgImg" alt="" />
      <canvas class="qr" id="qrCode-canvas"></canvas>
    </div>
    <div v-if="showPoster" class="stp-cent stp-cent-show">
      <div class="cent-wrap animate__animated animate__zoomIn">
        <img class="c-top" :src="topImg" alt="" />
        <img class="c-bg c-bg-show" :src="imgUrl" alt />
        <!-- <img class="c-btn" :src="btnImg" alt="" /> -->
        <div class="c-btn-2 user-btn" @click="handleSaveImg">保存到相册</div>
        <img
          class="c-close"
          @click="close"
          src="https://cdnvue.gymcity.com.cn/uploads/b9613ad5441024843dc083a522a19d9e.webp"
        />
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
export default {
  name: 'trans-coach-course',

  components: {},

  props: {},

  data() {
    return {
      bgImg: this['$store'].state.solarTerms.bgImg,
      btnImg: this['$store'].state.solarTerms.btnImg,
      topImg: this['$store'].state.solarTerms.topImg,
      imgUrl: '',
      showMask: false,
      showPoster: false
    }
  },

  computed: {
    user() {
      return this['$store'].state.user.user
    },
    // 分享二维码链接
    qrcodeUrl() {
      let fid = this.user.uid
      let sFrom = 'solarTerms'
      return (
        this.$http._getVueH5Url().replace('#/', '') +
        `?path=acceptrecommend&fid=${fid}&s_from=${sFrom}&scope=snsapi_userinfo&uno=${this.$http.getLogId(
          fid
        )}&log_time=solarTerms`
      )
    }
  },

  watch: {},

  created() {},

  mounted() {
    this.getImg()
  },

  destroyed() {},

  methods: {
    handleSaveImg() {
      this.$betterwe.onAppSaveImage({
        data: this.imgUrl,
        type: 'base64'
      })
      this['$http'].get('member/index?a=shareLogPush', {
        from: `${this['$store'].state.solarTerms.curTitle}节气海报-保存-app`,
        from_id: 240706
      })
    },
    close() {
      this.showPoster = false
      this.showMask = false
      this.$emit('close')
    },
    /**
     * 生成海报
     */
    getImg() {
      const that = this
      console.log('that.$refs.box', this.qrcodeUrl)
      window.scrollTo(0, 0)
      // this["$Indicator"].open({
      //   text: "正在生成图片...",
      //   spinnerType: "fading-circle",
      // });
      setTimeout(() => {
        that.showMask = true
      }, 300)
      setTimeout(() => {
        this.$nextTick(() => {
          // 合成分享图
          let canvas = document.getElementById('qrCode-canvas')
          QRCode.toCanvas(canvas, that.qrcodeUrl, (error) => {
            if (error) {
              setTimeout(() => {
                that.showMask = false
              }, 500)
              console.log(error)
            } else {
              // that.showMask = true;
              html2canvas(document.getElementById('box'), {
                backgroundColor: null,
                useCORS: true
              })
                .then(function (canvas) {
                  // that["$Indicator"].close();
                  that.imgUrl = canvas.toDataURL()
                  that.$emit('over')
                  // window.scrollTo(0, 0);
                  that.showMask = true
                  that.showPoster = true
                  // setTimeout(() => {
                  //   that["$Toast"]({
                  //     message: "图片已生成，长按保存分享给你的好友吧",
                  //     position: "middle",
                  //     duration: 3000,
                  //   });
                  // }, 100);
                })
                .catch((err) => {
                  setTimeout(() => {
                    that.showMask = false
                  }, 500)
                })
            }
          })
        })
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.solar-terms-poster {
  display: flex;
  flex-direction: column;
  align-items: center;
  .stp-mask {
    background-color: #000;
    position: fixed;
    top: 0;
    opacity: 0.6;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .stp-cent {
    width: vw(285);
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: vw(9999);
    // 测试代码
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -55%);
    // z-index: 100;
    img {
      display: block;
    }
    .c-top {
      width: 100%;
      margin-bottom: vw(-1);
    }
    .c-bg {
      width: 100%;
      min-height: vw(503);
    }
    .c-bg-show {
      border-radius: vw(6);
    }
    .c-btn {
      width: vw(217);
      margin-top: vw(12);
    }
    .c-btn-2 {
      width: vw(180);
      margin-top: vw(12);
      height: vw(40);
      line-height: vw(40);
      text-align: center;
      border-radius: vw(20);
      background-color: #f04646;
      font-size: vw(14);
      font-weight: 500;
      color: #fff;
    }
    #qrCode-canvas {
      width: vw(50) !important;
      height: vw(50) !important;
      position: absolute;
      top: vw(442);
      right: vw(18);
    }
    .c-close {
      width: vw(26);
      margin-top: vw(30);
    }
  }
  .stp-cent-show {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -55%) scale(0.9);

    z-index: 100;
    .cent-wrap {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  @media (max-height: 700px) {
    /* 在屏幕宽度小于或等于600px时应用的样式 */
    .stp-cent-show {
      transform: translate(-50%, -55%) scale(0.8);
    }
  }
}
</style>
